import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchReceitasReport } from '../actions/receitasFinanceirasActions'
import { DateTime } from 'luxon'
import { Datepicker, Loader } from 'modules/shared'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import Select from 'react-select'
import { numFormat } from 'helpers'

const { SearchBar } = Search

const ExportCSV = (props) => {
    const handleClick = () => props.onExport()
    return <button style={{ borderRadius: 0 }} className="btn btn-info btn-sm" disabled={props.disabled} onClick={handleClick}>Exportar CSV</button>
}

class ReceitasFinanceiras extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            dateIni: DateTime.local().minus({ days: 1 }).startOf('month').toJSDate(),
            dateEnd: DateTime.local().minus({ days: 1 }).endOf('month').toJSDate(),
            filteredCompanies: [],
        }
    }

    componentDidMount() {
        if (!this.props.receitasFinState.dados)
            this.props.fetchReceitasReport(this.state)
    }

    updateDates(dates) {
        if (dates.length >= 1 && (DateTime.fromJSDate(this.state.dateIni).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[0]).toFormat('yyyyMMdd') || DateTime.fromJSDate(this.state.dateEnd).toFormat('yyyyMMdd') !== DateTime.fromJSDate(dates[1]).toFormat('yyyyMMdd'))) {
            if (dates.length === 1)
                this.setState({ dateIni: dates[0], dateEnd: dates[0] })
            else
                this.setState({ dateIni: dates[0], dateEnd: dates[1] })
        }
    }

    filterCompanies(value) {
        let _ids = value.map(v => v.value)
        this.setState({
            filteredCompanies: this.props.receitasFinState.dados.empresas.filter(p => _ids.includes(p._id)).map(p => p._id)
        })
    }

    render() {

        let { loading, dados } = this.props.receitasFinState

        if (loading)
            return <Loader />

        let empresas = dados && dados.empresas && dados.empresas.length ? dados.empresas : []
        const options = empresas.map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }))

        const columns = [
            { dataField: 'index', text: 'index', sort: false, hidden: true, csvExport: false },
            { dataField: 'nomeEmpresa', text: 'Empresa', sort: true },
            { dataField: 'dataPgto', text: 'Data Pgto', sort: true },
            { dataField: 'docto', text: 'Documento', sort: true },
            { dataField: 'valor', text: 'Valor', sort: true, formatter: cell => numFormat(cell, 2), csvFormatter: cell => numFormat(cell, 2) },
            { dataField: 'vl_rec_fin', text: 'Receita financeira', sort: true, formatter: cell => numFormat(cell, 2), csvFormatter: cell => numFormat(cell, 2) },
        ]

        const toolkitProps = { keyField: 'index', data: dados ? dados.report || [] : [], columns, search: { searchFormatted: true }, exportCSV: true }

        return (
            <div className="container-fluid">

                <div className="row mb-4">

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Select
                            options={options}
                            defaultValue={empresas.filter(p => this.state.filteredCompanies.includes(p._id)).map(p => Object.assign({}, { value: p._id, label: p.nomeEmpresa }))}
                            isMulti
                            placeholder="Filtrar empresas..."
                            classNamePrefix="react-select"
                            onChange={value => this.filterCompanies(value)}
                        />
                    </div>

                    <div className="col col-sm-4 col-md-3 mt-2">
                        <Datepicker
                            defaultDate={[this.state.dateIni, this.state.dateEnd]}
                            onChange={dates => this.updateDates(dates)}
                        />
                    </div>

                    <div className="col mt-2">
                        <button onClick={() => this.props.fetchReceitasReport(this.state)} className="btn btn-primary btn-sm">
                            <i className="fas fa-sync-alt pr-2"></i>
                            Filtrar
                        </button>
                    </div>

                </div>

                <div className="row mr-2">

                    <div className="col">

                        <ToolkitProvider {...toolkitProps}>
                            {props =>
                                <Fragment>
                                    <div className="row mb-3">
                                        <div className="col col-sm-4 col-md-3">
                                            <SearchBar delay={250} placeholder="Pesquisar na tabela..." className="form-control-sm" {...props.searchProps} />
                                        </div>
                                        <div className="col">
                                            <ExportCSV {...props.csvProps} disabled={props.baseProps.data.length ? false : true} />
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col" style={{ fontSize: '.8rem' }}>
                                            <p className="mb-0"><strong>Valor total:</strong> {numFormat(dados ? dados.valorTotal : 0, 2 , true)}</p>
                                            <p className="mb-0"><strong>Receita financeira total:</strong> {numFormat(dados ? dados.receitaTotal : 0, 2 , true)}</p>
                                        </div>
                                    </div>

                                    <BootstrapTable
                                        {...props.baseProps}
                                        bootstrap4
                                        hover
                                        defaultSorted={[{ dataField: 'data', order: 'asc' }]}
                                        classes="table-sm table-font-size"
                                        wrapperClasses="table-responsive"
                                        pagination={paginationFactory({ sizePerPage: 50, sizePerPageList: [50, 100, 150, 200], showTotal: true, paginationTotalRenderer: (from, to, size) => (<span className="pl-3">Exibindo linhas {from} a {to} de {size}</span>) })}
                                        noDataIndication={'Sem dados'}
                                    />
                                </Fragment>
                            }
                        </ToolkitProvider>

                    </div>

                </div>

            </div>
        )
    }
}

const mapStateToProps = store => ({ receitasFinState: store.receitasFinState })
const mapDispatchToProps = dispatch => bindActionCreators({ fetchReceitasReport }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ReceitasFinanceiras)